/**
 * withBookings
 * HOC for wrapping the provided component with BookingsProvider
 */

import React from 'react'

import BookingsProvider from './bookings-provider'

export default function withBookings (WrappedComponent) {
  return function BookingsProviderHOC(props) {
    return (
      <BookingsProvider {...props}>
        <WrappedComponent {...props} />
      </BookingsProvider>
    )
  }
}
